/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_EyebrowInputs */

const en_directory_mcp_eyebrow = /** @type {(inputs: Directory_Mcp_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP integration`)
};

const zh_directory_mcp_eyebrow = /** @type {(inputs: Directory_Mcp_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP 集成`)
};

/**
* | output |
* | --- |
* | "MCP integration" |
*
* @param {Directory_Mcp_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_eyebrow = /** @type {((inputs?: Directory_Mcp_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_eyebrow(inputs)
	return zh_directory_mcp_eyebrow(inputs)
});
export { directory_mcp_eyebrow as "directory.mcp.eyebrow" }